import React, { useEffect, useState } from "react";
import { utils } from "../../utils";
import { Drawer, Form, Input, Button, Switch, message } from "antd";
import { useDispatch } from "react-redux";
import { setSavedCards, setPaymentCardData } from "../../includes/navSlice";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Space, Divider } from "antd";
import jwt_decode from "jwt-decode";
import { useGoogleLogin } from "@react-oauth/google";
import { MapUpdate, FormInput, CustomDrawer } from "../../components";

const LoginSignupModal = ({
  myClass,
  openSignIn,
  setOpenSignIn,
  loginStyle,
}) => {

  const [modalemail, setModalEmail] = useState("");
  const [modalphone, setModalPhone] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [phoneFormat, setPhoneFormat] = useState("US");

  const [open, setOpen] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [codeEntry, setCodeEntry] = useState(false);
  const [os, setOs] = useState("");
  const [model, setModel] = useState("");
  //const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = "";

  useEffect(() => {
    window.document.body.style.overflow = open ? "hidden" : "";
    setIsSignup(false);
  }, [open]);


  useEffect(() => {
    setOs(utils.getOs); // added parentheses to call function
    setModel(utils.getBrowser); // added parentheses to call function
    initEL();
  }, []);

  useEffect(() => {
    if (openSignIn) {
      setOpen(true);
    }
  }, [openSignIn]);

  useEffect(() => {
    if (utils.getStorage("__el_iphone")) {
      setModalPhone(utils.getStorage("__el_iphone"));
    }
    if (utils.getStorage("__el_iemail")) {
      setModalEmail(utils.getStorage("__el_iemail"));
    }
  }, [utils.getStorage("__el_iphone"), utils.getStorage("__el_iemail")]);


  const responseGoogle = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const posturl = "https://www.googleapis.com/oauth2/v3/userinfo";
        const header = { Authorization: `Bearer ${response.access_token}` };
        const dataToPost = "";
        const res = await utils.fetchURL(posturl, "GET", dataToPost, header);
        let data = await res.json();
        data = {
          ...data,
          accessToken: response.access_token,
          lastName: data.family_name,
          firstName: data.given_name,
        };
        onFastLogin(data.email, "google", data);
        //console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
  });

  const onFastLogin = async (email, platform = "", data = {}) => {
    try {
      if (!platform) {
        platform = "google";
      }
      if (platform === undefined) {
        platform = "google";
      }
      if (utils.isValidEmail(email)) {
        const localtime = await utils.getTime();
        const body = {
          rtype: "googlecontinue",
          email: email,
          os: os,
          model: model,
          platform: platform,
          localtime: localtime,
          ...data,
        };
        await doLogin(body, email);
      }
    } catch (e) {
      message.error(e.message);
    }
  };

  const getAuth = async (thisauth) => {
    try {
      let localEL = "";
      let local_token = "";

      const ed = await utils.getStorage("__el_data_access_token");
      const lt = await utils.getStorage("__el_data_local_token");
      localEL = ed ? ed : "";
      if (lt) {
        local_token = utils.getStorage("__el_data_local_token");
        utils.setStorage("__el_data_local_token", local_token);
      } else {
        local_token = uuidv4();
        utils.setStorage("__el_data_local_token", local_token);
      }

      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-local-token": local_token,
        "x-auth-token": localEL,
      };

      if (thisauth) {
        headers["x-auth-data"] = thisauth;
      }

      const target = utils.AUTH_URL;
      const header = new Headers(headers);
      const posturl = `${utils.BASE_URL}${target}`;
      const dataToPost = JSON.stringify({ rtype: "auth" });
      const res = await utils.fetchURL(posturl, "POST", dataToPost, header);
      const data = await res.json();
      let obj = JSON.parse(JSON.stringify(data));
      let objData = obj?.data;

      if (objData) {
        await utils.setStorage(
          "__el_data_access_token",
          objData.auth.access_token
        );
        await utils.setStorage(
          "__el_data_login_status",
          objData.credentials.el_login
        );
        await utils.setStorage("__el_data_email", objData.credentials.email);
        await utils.setStorage(
          "__el_data_first_name",
          objData.credentials.firstname
        );
        await utils.setStorage(
          "__el_data_last_name",
          objData.credentials.lastname
        );
        await loadEmailData(
          objData.credentials.email,
          objData.auth.access_token
        );
        setOpen(false);
      } else {
        message.error(data?.msg);
      }
    } catch (e) {
      message.error(e.message);
    }
  };

  const loadEmailData = async (email, auth) => {
    try {
      const target = `${utils.USER_CALL}?email=${email.toLowerCase()}`;
      const header = new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + auth,
      });
      const posturl = `${utils.BASE_URL}${target}`; //utils.GET_URL;
      const dataToPost = "";
      const response = await utils.fetchURL(posturl, "GET", dataToPost, header);
      const statusCode = await response.status;

      if (statusCode === 200) {
        const data = await response.json();
        await dispatch(setPaymentCardData(data.user.paymentCards));
        await dispatch(setSavedCards(JSON.stringify(data.user.paymentCards)));
      } else {
      }
    } catch (e) {}
  };

  const initEL = async () => {
    try {
      const ellogin = await utils.getStorage("__el_data_el_login");
      const email = await utils.getStorage("__el_data_email");
      if (utils.isValidEmail(email) && ellogin === "1") {
        setIsLoggedIn(true);
      } else if (utils.isValidEmail(email)) {
        setIsLoggedIn(true);
      } else if (ellogin === "1") {
        setIsLoggedIn(true);
      }
    } catch (e) {
      message.error(e.message);
    }
  };

  const handleCancel = async () => {
    if (openSignIn) {
      await setOpenSignIn(false);
      window.document.body.style.overflow = "auto";
    }
    setOpen(false);
  };

  const handleSwitch = () => {
    let email = "";
    let phone = document.getElementById("modalphone").value;
    phone = extractDigits(phone);
    if (document.getElementById("modalemail")) {
      email = document.getElementById("modalemail").value;
      setModalEmail(email);
    }
    setModalPhone(phone);
    setIsSignup(!isSignup);
  };

  function extractDigits(str) {
    return (str || "").replace(/\D/g, "");
  }

  const doLogin = async (obj, user) => {
    try {
      if (utils.isValidEmail(user) || utils.isValidPhone(user)) {
        setLoading(true);
        const target = utils.USER_URL;
        const header = new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + authToken,
        });
        const posturl = `${utils.BASE_URL}${utils.USER_URL}`; //utils.POST_URL;
        const obj2 = JSON.stringify({
          ...obj,
          target: target,
          token: authToken,
        });
        const dataToPost = await utils.cipherEncode(obj2);
        const res = await utils.fetchURL(posturl, "POST", dataToPost, header);
        const data = await res.json();

        if (data?.msg === "Success") {
          if (data?.screen === "HomeScreen") {
            let thisauth = jwt_decode(data.token);
            await utils.setStorage("__el_data_login_token", data?.token);
            thisauth = await utils.base64Encode(JSON.stringify(thisauth));
            //let decryptedStr = await utils.base64Decode(thisauth);
            await utils.removeStorage("__el_iphone");
            if(utils.removeStorage("__el_ipemail")) await utils.removeStorage("__el_iemail");
            await getAuth(thisauth);
            window.location.reload(true);
          } else if (data?.screen === "SignInOTPScreen") {
            setCodeEntry(true);
            setModalEmail(data?.email);
          } else if (data?.screen === "MyAccountEditScreen") {
            let thisauth = jwt_decode(data.token);
            await utils.setStorage("__el_data_login_token", data?.token);
            thisauth = await utils.base64Encode(JSON.stringify(thisauth));
            //let decryptedStr = await utils.base64Decode(thisauth);
            await getAuth(thisauth);
            window.location.reload(true);
            //await navigate('/edit-address/delivery/'+data?.editid, {user: email});
          }
        } else {
          if (data?.screen === "SignUpScreen") {
            message.error(data?.msg);
            await navigate("/signup", { message: data?.msg, replace: false });
            return;
          }
          message.error(data?.msg);
          await navigate("/signin", { replace: false });
        }
      } else {
        await navigate("/signin", { replace: false });
      }
    } catch (e) {
      message.error(e.message);
    }
  };

  const handleLogin = async () => {
    if (!codeEntry) {
        try {
          let phone = document.getElementById("modalphone").value;
          phone = extractDigits(phone);
          if (!phone) {
            message.error("Phone number is required!");
            return false;
          }
          setModalPhone(phone);
          await utils.setStorage("__el_iphone", phone);

          const localtime = await utils.getTime();
          const body = {
            rtype: "login",
            email: phone,
            phone: phone,
            os: os,
            model: model,
            localtime: localtime,
          };
          await doLogin(body, phone);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          message.error("Error logging in:", error.message);
          // Handle error
        }
    } else {
        try {
          const phone = await utils.getStorage("__el_iphone");
          if (!phone) {
            message.error("Phone number is required!");
            return false;
          }
          let phonecode = document.getElementById("phonecode").value;
          if (!phonecode) {
            message.error("Phone code is required!");
            return false;
          }
          setPhoneCode(phonecode);

          const localtime = await utils.getTime();
          const body = {
              rtype: "checkcode",
              phoneotp: phonecode,
              phone: phone,
              emailotp: "",
              email: modalemail,
              os: os,
              model: model,
              localtime: localtime,
          };
          await doLogin(body, modalemail);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          message.error("Error logging in:", error.message);
          // Handle error
        }
    }
  };

  const doSignUp = async (obj, user) => {
    try {
      if (utils.isValidEmail(user) || utils.isValidPhone(user)) {
        setLoading(true);
        const target = utils.USER_URL;
        const header = new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + authToken,
        });
        const posturl = `${utils.BASE_URL}${utils.USER_URL}`; //utils.POST_URL;
        let dataToPost = JSON.stringify({
          ...obj,
          target: target,
          token: authToken,
        });
        //console.log(dataToPost);
        dataToPost = await utils.cipherEncode(dataToPost);
        const res = await utils.fetchURL(posturl, "POST", dataToPost, header);
        const data = await res.json();

        if (data?.msg === "Success") {
          if (data?.screen === "HomeScreen") {
            let thisauth = jwt_decode(data.token);
            await utils.setStorage("__el_data_login_token", data?.token);
            thisauth = await utils.base64Encode(JSON.stringify(thisauth));
            //let decryptedStr = await utils.base64Decode(thisauth);
            setCodeEntry(false);
            await utils.removeStorage("__el_iphone");
            await utils.removeStorage("__el_iemail");
            await getAuth(thisauth);
            window.location.reload(true);
          } else if (data?.screen === "SignInScreen") {
            let thisauth = jwt_decode(data.token);
            await utils.setStorage("__el_data_login_token", data?.token);
            thisauth = await utils.base64Encode(JSON.stringify(thisauth));
            await getAuth(thisauth);
            setCodeEntry(false);
            window.location.reload(true);
          } else if (data?.screen === "OtpScreen") {
            setModalEmail(modalemail);
            setCodeEntry(true);
            setIsSignup(true);
          } else {
            message.error(data?.msg);
          }
        } else {
          message.error(data?.msg);
        }
      } else {
        await navigate("/signin", { replace: false });
      }
    } catch (e) {
      message.error(e.message);
    }
  };

  const handleSignup = async () => {
    try {
      if (!codeEntry) {
        const email = document.getElementById("modalemail").value;
        let phone = document.getElementById("modalphone").value;
        phone = extractDigits(phone);
        // Call signup API here
        if (!phone) {
          message.error("Phone is required!");
          return false;
        }
        if (!email) {
          message.error("Email is required!");
          return false;
        }
        setModalPhone(phone);
        setModalEmail(email);
        await utils.setStorage("__el_iemail", email);
        await utils.setStorage("__el_iphone", phone);

        const localtime = await utils.getTime();
        const body = {
          rtype: "sendcode",
          email: email,
          phone: phone,
          os: os,
          model: model,
          localtime: localtime,
        };

        await doSignUp(body, email);
        setLoading(false);
      } else {
        const email = await utils.getStorage("__el_iemail");
        const phone = await utils.getStorage("__el_iphone");
        const emailcode = document.getElementById("emailcode").value;
        const phonecode = document.getElementById("phonecode").value;

        if (!email) {
          message.error("Email is required!");
          return false;
        }
        if (!phone) {
          message.error("Phone is required!");
          return false;
        }
        if (!emailcode) {
          message.error("Email Code is required!");
          return false;
        }
        if (!phonecode) {
          message.error("Phone Code is required!");
          return false;
        }
        setEmailCode(emailcode);
        setPhoneCode(phonecode);

        const localtime = await utils.getTime();
        const body = {
          rtype: "checkcode",
          phoneotp: phonecode,
          phone: phone,
          emailotp: emailcode,
          email: email,
          os: os,
          model: model,
          localtime: localtime,
        };
        await doSignUp(body, modalemail);

        setLoading(false);
        setOpen(false);
      }
    } catch (error) {
      setLoading(false);
      message.error("Error signing up:", error);
      // Handle error
    }
  };

  const openDashBoard = async () => {
    await navigate("/dashboard", { replace: false });
  };

  return (
    <>
      {!isLoggedIn && (
        <a
          href="#"
          className={myClass}
          style={loginStyle}
          onClick={() => {
            return false;
          }}
          onMouseDown={() => setOpen(true)}
        >
          Login
        </a>
      )}
      {isLoggedIn && (
        <a
          href="#"
          className={myClass}
          onClick={() => {
            return false;
          }}
          onMouseDown={() => openDashBoard()}
        >
          Dashboard
        </a>
      )}

      <Drawer
          title={isSignup ? "Sign Up" : "Login"}
          open={open}
          footer={null}
          closable={false}
          maskClosable={true}
          placement="right"
          onClose={() => handleCancel()}
          size={`large`}
          extra={
            <Button
              key="back"
              className="c__button"
              onClick={() => handleCancel()}
            >
              Close
            </Button>
          }
      >
        <div
          key={uuidv4()}
          tabIndex="0"
          style={{ backgroundColor: "rgba(204,220,205,0.2)", padding: 20 }}
        >
          <div style={{ marginBottom: 20 }}>
            {!codeEntry && (<FormInput
                label={`Phone *`}
                secureTextEntry="text"
                inputType="inputmask"
                inputId="modalphone"
                mask="(999) 999-9999"
                defaultValue={modalphone}
                containerStyle={{
                    marginTop: 15,
                    width: '100%',
                    textAlign: 'left',
                }}
                inputContainerStyle={{
                    backgroundColor: '#ffffff',
                    width: '100%'
                }}
                inputLabelStyle={{
                    fontSize: 16
                }}
                inputClass={'cus_input'}
                //disabled={isSignup && codeEntry ? true : false}
            />)}
            {codeEntry && (<FormInput
                label={`Phone Code *`}
                secureTextEntry="text"
                inputType="input"
                inputId="phonecode"
                defaultValue={phoneCode}
                containerStyle={{
                    marginTop: 15,
                    width: '100%',
                    textAlign: 'left',
                }}
                inputContainerStyle={{
                    backgroundColor: '#ffffff',
                    width: '100%'
                }}
                inputLabelStyle={{
                    fontSize: 16
                }}
                inputClass={'cus_input'}
                //disabled={isSignup && codeEntry ? true : false}
            />)}
          </div>

          <div style={{ marginBottom: 20 }}>
            {isSignup && !codeEntry && (<FormInput
                label={`Email *`}
                secureTextEntry="email"
                inputType="input"
                inputId="modalemail"
                defaultValue={modalemail}
                containerStyle={{
                    marginTop: 15,
                    width: '100%',
                    textAlign: 'left',
                }}
                inputContainerStyle={{
                    backgroundColor: '#ffffff',
                    width: '100%'
                }}
                inputLabelStyle={{
                    fontSize: 16
                }}
                inputClass={'cus_input'}
            />)}
            {isSignup && codeEntry && (<FormInput
                label={`Email Code *`}
                secureTextEntry="text"
                inputType="input"
                inputId="emailcode"
                defaultValue={emailCode}
                containerStyle={{
                    marginTop: 15,
                    width: '100%',
                    textAlign: 'left',
                }}
                inputContainerStyle={{
                    backgroundColor: '#ffffff',
                    width: '100%'
                }}
                inputLabelStyle={{
                    fontSize: 16
                }}
                inputClass={'cus_input'}
            />)}
          </div>

          <Divider style={{ marginTop: 0 }} />
          <div style={{ marginTop: 0, textAlign: "left" }}>
            <Switch checked={isSignup} onChange={()=> handleSwitch()} />
            <span style={{ marginLeft: 8, fontFamily: 'Montserrat' }}>
              {isSignup
                ? `Already have an account? Login`
                : `Don't have an account? Sign up`}
            </span>
          </div>
          <Divider style={{ marginTop: -8 }} />

          <Button
            key="submit"
            className="c__button"
            loading={loading}
            onClick={isSignup ? handleSignup : handleLogin}
          >
            {isSignup ? `${codeEntry ? "Signup" : "Get Code"}` : `${codeEntry ? "Login" : "Get Code"}` }
          </Button>

          <Divider style={{ marginTop: 0 }} />
          <div style={{ width: "100%", textAlign: "center", marginTop: -8 }}>
            OR
          </div>
          <Divider style={{ marginTop: 8 }} />
          <div
            className="continue-wrap"
            style={{
              left: "50%",
              marginLeft: "-130px",
              width: "fit-content",
              position: "relative",
            }}
          >
            <Space direction="vertical">
              <button
                onClick={responseGoogle}
                className="continue continue-google"
              >
                Continue with google
              </button>
            </Space>
            <Divider />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default LoginSignupModal;
